/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Line_Spacing_HelpInputs */



/**
* | output |
* | --- |
* | "Spacing between lines (0-50%)" |
*
* @param {Options_Display_Line_Spacing_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_line_spacing_help = /** @type {((inputs?: Options_Display_Line_Spacing_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Line_Spacing_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Espacement entre les lignes (0-50%)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeilenabstand (0-50%)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Spaziatura tra le righe (0-50%)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Расстояние между строками (0-50%)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Espaciado entre líneas (0-50%)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("行间距（0-50%）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("行間隔（0～50%）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पंक्तियों के बीच की दूरी (0-50%)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Espaçamento entre linhas (0-50%)")
	return /** @type {LocalizedString} */ ("Spacing between lines (0-50%)")
});